import { Link, Typography } from "@aircall/tractor";
import { useTranslation } from "react-i18next";

import { TranscriptionMessageTitle } from "../../../TranscriptionMessageTitle";
import { TranscriptionSubTitle } from "../../../TranscriptionSubTitle";

import TranscriptionNoSpeechDetectedSvg from "@/assets/transcription_no_speech_detected.svg?react";

export function TranscriptionNoSpeechDetected() {
  const { t } = useTranslation();

  return (
    <>
      <TranscriptionNoSpeechDetectedSvg />
      <TranscriptionMessageTitle>
        {t("no_transcript.no_speech_detected_title")}
      </TranscriptionMessageTitle>
      <TranscriptionSubTitle>
        {t("no_transcript.no_speech_detected_description")}
      </TranscriptionSubTitle>
      <Link target="_blank" href={t("no_transcript.no_speech_detected_link")}>
        <Typography variant="bodyMediumS" color="text-interactive-primary">
          {t("learn_more")}
        </Typography>
      </Link>
    </>
  );
}
